'use strict';

/**
*
* BUTTON
*
* mode:
*      DISABLED
*      NORMAL (by default)
*      NOTICE
*      ACTION
*      BLEND_WHITE
*      BLEND_BLACK
*		ALERT
*/

var React = require('react'),
    _ = require('lodash');

var Button = React.createClass({
    displayName: 'Button',


    propTypes: {
        label: React.PropTypes.string,
        active: React.PropTypes.bool,
        mode: React.PropTypes.string,
        onClick: React.PropTypes.func,
        className: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array])
    },

    getDefaultProps: function getDefaultProps() {
        return {
            label: '',
            active: false,
            mode: 'NORMAL'
        };
    },

    getInitialState: function getInitialState() {
        return {
            keyboardActive: false
        };
    },

    changeStateProp: function changeStateProp(property, value) {
        var state = this.state;
        state[property] = value;
        this.setState(state);
    },

    onKeyPress: function onKeyPress(event) {
        //Check for space
        if (event.keyCode == 32) {
            event.stopPropagation();
            event.preventDefault();

            this.changeStateProp('keyboardActive', true);

            this.props.onClick(event);

            setTimeout(function () {
                this.changeStateProp('keyboardActive', false);
            }.bind(this), 100);

            return false;
        }
    },

    render: function render() {

        var icon = this.props.icon ? React.createElement('span', { className: this.props.icon }) : '',
            className = _.concat(['button', 'mode_' + this.props.mode.toLowerCase()], this.props.className);

        if (this.props.active || this.state.keyboardActive) {
            className.push('active');
        }

        if (this.props.disabled) {
            className.push('disabled');
        }

        if (_.isFunction('this.props.onClick')) {
            className.push('clickable');
        }

        return React.createElement(
            'div',
            { onClick: this.props.onClick,
                className: className.join(' '),
                onKeyPress: this.onKeyPress,
                tabIndex: 0 },
            this.props.label,
            icon,
            this.props.children
        );
    }
});

module.exports = Button;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fdna-common-components/dist/components/Forms/Button.js
// module id = 25
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30